<template>
  <div class="login-wrap">
    <div v-if="loading" class="loading-box">
      <div class="spinner"></div>
      <p>{{ tipText }}</p>
    </div>
    <div v-if="errorMsg" class="error-box">
      <p class="error">{{ errorMsg }}</p>
      <button @click="startLogin">重试</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "FeishuLogin",
  data() {
    return {
      loading: true,
      tipText: "飞书免登初始化...",
      errorMsg: "",
      done: false,
      // 配置信息
      FEISHU_APP_ID: "cli_a374bc2dd1fa500c",
      FEISHU_SCOPE: "contact:user.base:readonly",
      SUBMIT_CODE_URL:"yonsuite/sso/feishuLogin",
    };
  },
  mounted() {
    this.startLogin();
  },
  methods: {
    showErr(msg) {
      this.loading = false;
      this.errorMsg = msg;
    },
    async startLogin() {
      this.loading = true;
      this.errorMsg = "";
      this.done = false;
      console.log("【1】startLogin开始执行");
      alert("【1】startLogin开始执行");

      if (!window.h5sdk) {
        console.log("【失败】window.h5sdk不存在");
        alert("【失败】window.h5sdk不存在");
        this.showErr("飞书SDK加载失败，请在飞书客户端打开");
        return;
      }
      console.log("【2】h5sdk对象存在，准备调用ready");
      alert("【2】h5sdk对象存在，准备调用ready");

      // // 10秒超时兜底
      // const timer = setTimeout(() => {
      //   if (!this.done) {
      //     this.done = true
      //     this.showErr('获取授权code超时')
      //     console.log('【超时】ready回调一直没进来')
      //     alert('【超时】ready回调一直没进来')
      //   }
      // }, 10000)

      window.h5sdk.ready(() => {
        // 缓存当前Vue实例，解决回调内this丢失
        // const vm = this;
        // const url = vm.SUBMIT_CODE_URL;

        console.log("【3】h5sdk.ready触发成功！");
        alert("【3】h5sdk.ready触发成功！");

        window.h5sdk.ready(() => {
          console.log("【3】h5sdk.ready触发成功！");
          alert("【3】h5sdk.ready触发成功！");
          window.tt.requestAccess({
            appID: this.FEISHU_APP_ID,
            scopeList: [this.FEISHU_SCOPE],
            success: async (res) => {
              console.log("【4】getAuthCode success，code=" + res.code);
              alert("【4】拿到code：" + res.code);
              if (this.done || !res.code) return;
              this.done = true;
              // 保存飞书返回的授权码，避免变量名覆盖
              const authCode = res.code;
              console.log("准备传给后端的code：", authCode);
              try {
                // fetch返回对象改名叫response，不再和飞书返回的res重名
                const response = await fetch(this.SUBMIT_CODE_URL, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({ code: authCode }),
                });
                const loginRes = await response.json();
                alert("【5】后端返回结果：" + JSON.stringify(loginRes));
                if (loginRes.code === 0 && loginRes.data) {
                  alert("登录成功");
                } else {
                  this.showErr(loginRes.msg || "code校验失败");
                }
              } catch (err) {
                console.error("fetch异常", err);
                alert("fetch调用后端接口异常：" + err.message);
                this.showErr("调用后端接口异常");
              }
            },
            fail: (err) => {
              console.error("【4】getAuthCode失败：", err);
              alert("【4】getAuthCode失败：" + JSON.stringify(err));
              if (!this.done) {
                this.done = true;
                this.showErr("获取授权code失败");
              }
            },
          });
        });
      });
    },
  },
};
</script>
<style scoped>
.login-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f5f6f7;
}
.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e0e0e0;
  border-top-color: #3370ff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 12px;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.error {
  color: #f54a45;
}
</style>
